import React from 'react';
import { AppLayout } from '../components/layout/AppLayout';
import { RequestsList } from '../components/features/RequestsList';

export const RequestsPage: React.FC = () => {
  return (
    <AppLayout title="Справки и сертификаты">
      <RequestsList />
    </AppLayout>
  );
};
